import * as HTMLElementCreator from '../../../libs/HTML/HTMLElementCreator';
import type { EditorInputConfig, EditorInputField } from './createEditorInput';
import { createEditorInput } from './createEditorInput';
import { BUTTON_STYLE } from '../EditorOverlayStyles';

export interface EditorIncrementInputConfig extends EditorInputConfig {
  increment?: number;
  buttonStyle?: Partial<CSSStyleDeclaration>;
}

export const INCREMENT_BUTTON_STYLE: Partial<CSSStyleDeclaration> = {
  ...BUTTON_STYLE,
  minWidth: '20x',
  fontSize: '0.9em',
  marginLeft: '2px',
};

export function createEditorIncrementInput(config: EditorIncrementInputConfig): EditorInputField {
  const { panel, label, input } = createEditorInput(config);
  const { increment = 1 } = config;

  const getIncrementedValue = (sign: -1 | 1): string => {
    const currentValue = parseInt(input.value, 10);
    const value = Math.floor(currentValue / increment) * increment + sign * increment;
    return config.restrictRegEx ? (value.toString().match(config.restrictRegEx) || ['0']).join('') : value.toString();
  };

  HTMLElementCreator.createButton({
    labelText: '-',
    parentElement: panel,
    style: config.buttonStyle ?? INCREMENT_BUTTON_STYLE,
    onClick: () => {
      input.value = getIncrementedValue(-1);
      config.onValueChanged(input.value);
    },
  });

  HTMLElementCreator.createButton({
    labelText: '+',
    parentElement: panel,
    style: config.buttonStyle ?? INCREMENT_BUTTON_STYLE,
    onClick: () => {
      input.value = getIncrementedValue(1);
      config.onValueChanged(input.value);
    },
  });

  return { panel, label, input };
}
